/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserConsentDto = {
    EmailConsentForLetsOrangeRecruitment: 'EMAIL_CONSENT_FOR_LETS_ORANGE_RECRUITMENT',
    AdditionalPersonalDataProcessingConsentOrange: 'ADDITIONAL_PERSONAL_DATA_PROCESSING_CONSENT_ORANGE',
    FutureRecruitmentDataProcessingConsentOrange: 'FUTURE_RECRUITMENT_DATA_PROCESSING_CONSENT_ORANGE'
} as const;

export type UserConsentDto = typeof UserConsentDto[keyof typeof UserConsentDto];



